import { checkStatus } from '../../utilities/fetch';
import { XMLHTTPResponse } from '../../utilities/types';
import { createQueryString } from '../../utilities/utilities';
import { permissionsPath, subscriptionsPath } from '../../utilities/api_relative_paths';
import { GetNewslettersResponse, Newsletter, Privilege } from '../types/types';
import {
  subscribeToNewsletter,
  unsubscribeFromNewsletter,
} from '../../services/newsletter/newsletter.api.service';

interface Payload {
  referrer: string;
  email?: string;
}

const getNewslettersForAA = (): Promise<GetNewslettersResponse> =>
  fetch(subscriptionsPath + createQueryString({ page: { size: 100 } }))
    .then((response: XMLHTTPResponse) => checkStatus(response))
    .then((response) => response.json())
    .catch(Promise.reject);

const toggleNewsletterSubscription = (
  newsletter: Newsletter,
  payload: Payload
): Promise<Newsletter> =>
  newsletter.subscribed
    ? unsubscribeFromNewsletter(newsletter.id, payload)
    : subscribeToNewsletter(newsletter, payload);

const getPrivilegeCheck = (permissionConstantName: string): Promise<Privilege> => {
  const query = createQueryString({ charge_credits: false });
  const path = `${permissionsPath}/${permissionConstantName}/${query}`;
  return fetch(path)
    .then((response: XMLHTTPResponse) => checkStatus(response))
    .then((response) => response.json())
    .catch(Promise.reject);
};

export { getNewslettersForAA, toggleNewsletterSubscription, getPrivilegeCheck };
